"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const utils_2 = require("./utils");
const aria_1 = require("./utils/aria");
const components_1 = require("./utils/InputElement/components");
const secureTransform = (value, current, secure) => secure
    ? [...value].map((v, i) => (v === utils_1.DISC ? current[i] : v)).join('')
    : value;
const TextInputElem = (0, react_1.forwardRef)((_a, ref) => {
    var { hasError, optional = false, success, label, onFocus, onBlur, onChange, prefix, suffix, secure, className, value } = _a, props = __rest(_a, ["hasError", "optional", "success", "label", "onFocus", "onBlur", "onChange", "prefix", "suffix", "secure", "className", "value"]);
    const id = (0, app_1.useCuid)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const disabled = Boolean(props.disabled);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!!label && ((0, jsx_runtime_1.jsx)(utils_2.Label, Object.assign({ optional: optional, htmlFor: id, inputKind: "text", className: (0, utils_1.cls)({
                    'focus-visible': focus,
                    'with-value': Boolean(value),
                }) }, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { children: label }))), (0, jsx_runtime_1.jsx)(utils_2.InputWrapper, Object.assign({ ref: ref, prefix: prefix, suffix: suffix, className: (0, utils_1.cls)({ 'focus-visible': focus }, className) }, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { children: (0, jsx_runtime_1.jsx)(components_1.InputInner, Object.assign({}, props, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { value: secure ? value.replaceAll(/./gu, utils_1.DISC) : value, id: id, onFocus: (ev) => {
                        onFocus(ev.target.value);
                        setFocus(true);
                    }, onBlur: (ev) => {
                        onBlur(ev.target.value);
                        setFocus(false);
                    }, onChange: (ev) => onChange((current) => secureTransform(ev.target.value, current, secure)) })) }))] }));
});
exports.TextInput = (0, react_1.forwardRef)((_a, ref) => {
    var { defaultValue } = _a, props = __rest(_a, ["defaultValue"]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { ref: ref, render: TextInputElem, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : '', inputType: "text" })));
});
